import { render, staticRenderFns } from "./AllNotification.vue?vue&type=template&id=2231d1d3&"
import script from "./AllNotification.vue?vue&type=script&lang=js&"
export * from "./AllNotification.vue?vue&type=script&lang=js&"
import style0 from "./AllNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports